import React from "react";

import { AppBar, Box, Container, Grid, Toolbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    appBarBottom: {
        border: "none",
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(0),
    },
    appBarBottomCopyright: {
        backgroundColor: "#363636",
        color: theme.palette.primary.contrastText,
        textAlign: "center",
        fontSize: "0.675rem",
    },
    logoBottom: {
        margin: theme.spacing(4),
        maxHeight: 72,
        [theme.breakpoints.down("sm")]: {
            margin: "16px 16px 16px -57px",
        },
    },
    footerItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 160,
        fontSize: "0.75rem",
        [theme.breakpoints.down("sm")]: {
            minHeight: 64,
            fontSize: "0.75rem",
            justifyContent: "flex-start",
            padding: "8px 0 16px 73px",
            borderBottom: `1px solid ${theme.palette.secondary.light}`,
        },
        "& a": {
            fontSize: "0.875em",
            paddingTop: 8,
            fontWeight: 500,
            display: "block",
        },
    },
    footerHolder: {
        backgroundColor: theme.palette.secondary.main,
        padding: 0,
    },
    footer: {
        backgroundColor: theme.palette.secondary.main,
        minHeight: 120,
    },
}));

const Footer = () => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Container maxWidth={false} className={classes.footerHolder}>
                <Container maxWidth={"lg"} className={classes.footer}>
                    <AppBar position="static" color="secondary" className={classes.appBarBottom} elevation={0}>
                        <Toolbar>
                            <Grid container>
                                <Grid item xs={12} md={3} className={classes.footerItem}>
                                    <img src={"./images/gusMono.png"} alt="GUS logo" className={classes.logoBottom} />
                                    <Box>
                                        <b>Główny Urząd Statystyczny</b>
                                        <br />
                                        Aleja Niepodległości 208 <br />
                                        00-925 Warszawa
                                        <br />
                                        <a
                                            href="https://stat.gov.pl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "inherit", textDecoration: "inherit" }}
                                        >
                                            Przejdż do Portalu Informacyjnego GUS
                                        </a>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={3} className={classes.footerItem}>
                                    <Box>
                                        Godzina pracy Urzędu: 8:15-16:15
                                        <br />
                                        Kancelaria: +48 22 608 30 00
                                        <br />
                                        kancelariaogolnaGUS@stat.gov.pl
                                        <br />
                                        <a
                                            href="mailto:kancelariaogolnaGUS@stat.gov.pl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "inherit", textDecoration: "inherit" }}
                                        >
                                            Elektroniczna Skrzynka Podawcza
                                        </a>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={3} className={classes.footerItem}>
                                    <Box>
                                        <a
                                            href="/#/deklaracja"
                                            rel="noopener noreferrer"
                                            style={{ color: "inherit", textDecoration: "inherit" }}
                                        >
                                            Deklaracja dostępności
                                        </a>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={3} className={classes.footerItem} style={{ paddingLeft: 0 }}>
                                    <Grid container spacing={0} alignContent={"center"} style={{ textAlign: "center" }}>
                                        <Grid item xs={12}>
                                            <b>Znajdż nas na:</b>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <a
                                                href="https://twitter.com/GUS_STAT"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "inherit", textDecoration: "inherit" }}
                                            >
                                                <img src={"./images/icons/RSI_www-05.png"} alt={"Twitter"} />
                                            </a>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <a
                                                href="https://www.youtube.com/channel/UC0wiQMElFgYszpAoYgTnXtg/featured"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "inherit", textDecoration: "inherit" }}
                                            >
                                                <img src={"./images/icons/RSI_www-06.png"} alt={"Youtube"} />
                                            </a>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <a
                                                href="https://www.linkedin.com/company/532930"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "inherit", textDecoration: "inherit" }}
                                            >
                                                <img src={"./images/icons/RSI_www-07.png"} alt={"LinkedIn"} />
                                            </a>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <a
                                                href="https://www.facebook.com/GlownyUrzadStatystyczny/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "inherit", textDecoration: "inherit" }}
                                            >
                                                <img src={"./images/icons/RSI_www-08.png"} alt={"Facebook"} />
                                            </a>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                </Container>
                <AppBar position="static" color="transparent" className={classes.appBarBottomCopyright} elevation={0}>
                    <Toolbar variant={"dense"} style={{ minHeight: 32 }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span>Copyright © 2018-{new Date().getFullYear()} Główny Urząd Statystyczny</span>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Container>
        </React.Fragment>
    );
};

export default Footer;
